/**
 * Take an array of items that have a group and create an object that maps group to item.
 * @param items An array of grouped items.
 * @returns An object of the form { [group]: item }
 */
export const indexByGroup = <T extends { group: string }>(items: T[]) => {
    return items.reduce<{ [group: string]: T }>((indexedItems, current) => {
        return { ...indexedItems, [String(current.group)]: current };
    }, {});
};
